import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kvr_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/register") && window.location.pathname !== "/") {
      localStorage.removeItem("kvr_token");
      localStorage.removeItem("kvr_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;

// Liefert eine verständliche deutsche Fehlermeldung statt "Fehler"
export function errMsg(err, fallback = "Unbekannter Fehler") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string" && d.trim()) return d;
  if (Array.isArray(d) && d.length) return d.map(x => x?.msg || JSON.stringify(x)).join(", ");
  const st = err?.response?.status;
  if (st === 413) return "Datei zu groß — bitte eine kleinere Datei hochladen";
  if (st === 401) return "Sitzung abgelaufen — bitte neu anmelden";
  if (st === 403) return "Keine Berechtigung für diese Aktion";
  if (st === 404) return `${fallback} (nicht gefunden)`;
  if (st === 502 || st === 503 || st === 504) return `${fallback} — Server antwortet gerade nicht (${st}), bitte in Kürze erneut versuchen`;
  if (st >= 500) return `${fallback} (Server-Fehler ${st})`;
  if (err?.code === "ECONNABORTED") return `${fallback} (Zeitüberschreitung)`;
  if (err && !err.response) return `${fallback} — keine Verbindung zum Server (Netzwerk prüfen)`;
  return fallback;
}
